<!--
  コンテンツ画面
-->
<template>
  <h4 class="d-flex my-4 align-items-center container">
    <img :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/return_book${1}.gif`"
         draggable="false"
         class="w-auto max-hr-2 me-2" />
    <span v-if="content != null">
      {{content.displayString ?? content.contentsName}}
    </span>
  </h4>

  <section class="container my-4" v-if="references != null && references.length > 0">
    <h6 class="my-2">
      参考資料
    </h6>
    <section class="border rounded-3">
      <div class="d-block m-2" v-for="r in references" :key="r.id">
        <svgicon v-if="r.fileContent == null"
                 name="box_arrow_up_right"
                 class="w-auto hr-1 me-2" />
        <svgicon v-if="r.fileContent != null"
                 name="download"
                 class="w-auto hr-1 me-2" />
        <a href="#">
          <span>
            {{r.displayString}}
          </span>
        </a>
      </div>
    </section>
  </section>

  <template v-if="content != null && content.contentsType=='test'">
    <test-container :test="content.testContent"
                    :testName="content.contentsName"
                    class="container my-4 py-4 border-top border-bottom" />
  </template>

  <template v-if="content != null && content.contentsType=='questionnaire'">
    <questionnaire-container :questionnaire="content.questionnaireContent"
                             :questionnaireName="content.contentsName"
                             class="container my-4 py-4 border-top border-bottom" />
  </template>

  <template v-if="content != null && content.contentsType=='music'">
    <audio-control :src="content.fileContent.fileUrl"
                   class="container"
                   :alreadyPlayed="[{start: 20, end: 40}, {start: 80, end: 100},]" />
  </template>

  <template v-if="content != null && content.contentsType=='movie'">
    <video-control :src="content.fileContent.fileUrl"
                   class="container max-vh-100"
                   :alreadyPlayed="[{start: 20, end: 40}, {start: 80, end: 100},]" />
  </template>

  <template v-if="content != null && content.contentsType=='pdf'">
    <pdf-control :src="content.fileContent.fileUrl"
                 :workerSrc="workerSrc" />
  </template>

  <section class="container-fluid container-md d-flex my-4">
    <a href="/Courses/Details" class="btn btn-outline-success">
      戻る
    </a>
    <a href="/Courses/Details" class="btn btn-outline-primary ms-auto">
      終了
    </a>
  </section>


</template>

<script>
  import { defineComponent } from "vue";
  import { xhrRequest, xhrErrors } from "utils/xhr";
  import Spinner from "utils/spinner";
  import { format } from 'date-fns';
  import validationErrors from "components/base/validation_errors";
  import viewer from "components/pdf_viewer/viewer";

  import AudioControl from "components/control/audio_control";
  import VideoControl from "components/control/video_control";
  import PdfControl from "components/control/pdf_control";
  import TestContainer from "components/container/test_container";
  import QuestionnaireContainer from "components/container/questionnaire_container";

  import { getParameter } from "utils/url";

  const onInit = () => {

  };

  const onMounted = function () {
    this.contentId = getParameter("id");
    this.loadContent();
  };

  const methods = {
    loadContent() {
      const spinner = new Spinner();
      this.loadCompleted = false;
      xhrRequest(
        "GET",
        `contents/${this.contentId}`,
        null,
        {
          success: data => {
            this.content = data;
          },
          error: (xhr, status, error) => {
          },
          complete: () => {
            if (this.loadCompleted) {
              spinner.stop();
            } else {
              this.loadCompleted = true;
            }
          },
        },
      );
      xhrRequest(
        "GET",
        `contents/reference`,
        null,
        {
          success: data => {
            this.references = data.contents;
          },
          error: (xhr, status, error) => {
          },
          complete: () => {
            if (this.loadCompleted) {
              spinner.stop();
            } else {
              this.loadCompleted = true;
            }
          },
        },
      );
    },
  };

  const computed = {
    hasPrev: function () {
      return this.currentPage > 1;
    },
    hasNext: function () {
      return this.currentPage < this.totalPages;
    }
  };

  export default defineComponent({
    template: "#container",
    updated() {
      if (this.$refs.audio) {
        this.$refs.audio.addEventListener("loadedmetadata", function () {
          this.audio = this.$refs.audio;
        }.bind(this), {once: true});
      }
    },
    components: {
      "viewer": viewer,
      "audio-control": AudioControl,
      "video-control": VideoControl,
      "test-container": TestContainer,
      "questionnaire-container": QuestionnaireContainer,
      "pdf-control": PdfControl,
    },
    data: () => {
      return {
        type: ["pdf", "movie", ""],
        content: null,
        references: [],
        loadCompleted: false,
        contentId: null,
        audio: null,
      }
    },
    props: {
      workerSrc: {
        type: String,
        require: true,
      },
    },
    created: onInit,
    mounted: onMounted,
    methods: methods,
    computed: computed,
  });
</script>
